import { LazyAction, LazyModule } from 'owa-bundling';
import { getStore as getDelayedItemStore } from './store/store';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "MailCompose" */ './lazyIndex');
});
export var lazyRemoveMailItemWithData = new LazyAction(lazyModule, function (m) { return m.removeMailItemWithData; });
export var lazyUndoLatestDelayedMailItem = new LazyAction(lazyModule, function (m) { return m.undoLatestDelayedMailItem; });
export { getDelayedItemStore };
//# sourceMappingURL=index.js.map